import React from 'react';
import styles from '../styles';
import { FaSms, FaUserSecret } from 'react-icons/fa';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';

const KeyDifference = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();

    const keyDifferenceStyles = {
        container: {
            ...styles.section,
            backgroundColor: '#f8f9fa',
            padding: isMobile ? '3rem 1rem' : '4rem 2rem',
        },
        subSection: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            maxWidth: '1000px',
            margin: '2rem 0',
            flexDirection: isMobile ? 'column' : 'row',
        },
        textContainer: {
            flex: 1,
            minWidth: '300px',
            padding: '2rem',
            textAlign: isMobile ? 'center' : 'left',
        },
        iconContainer: {
            flex: '0 0 150px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            order: isMobile ? -1 : 0,
        },
        icon: {
            fontSize: '6rem',
            color: styles.brandColor,
        },
        headline: {
            ...styles.h2,
            textAlign: isMobile ? 'center' : 'left',
            fontSize: '2rem',
        },
        body: {
            ...styles.bodyText,
            textAlign: isMobile ? 'center' : 'left',
        }
    };

    const reverseSubSection = { ...keyDifferenceStyles.subSection, flexDirection: isMobile ? 'column' : 'row-reverse' };

    return (
        <section style={keyDifferenceStyles.container}>
            <div style={keyDifferenceStyles.subSection}>
                <div style={keyDifferenceStyles.iconContainer}>
                    <FaSms style={keyDifferenceStyles.icon} />
                </div>
                <div style={keyDifferenceStyles.textContainer}>
                    <h2 style={keyDifferenceStyles.headline}>{t('keyDifference.smsHeadline')}</h2>
                    <p style={keyDifferenceStyles.body}>
                        {t('keyDifference.smsBody')}
                    </p>
                </div>
            </div>

            <div style={reverseSubSection}>
                <div style={keyDifferenceStyles.textContainer}>
                    <h2 style={keyDifferenceStyles.headline}>{t('keyDifference.privacyHeadline')}</h2>
                    <p style={keyDifferenceStyles.body}>
                        {t('keyDifference.privacyBody')}
                    </p>
                </div>
                <div style={keyDifferenceStyles.iconContainer}>
                    <FaUserSecret style={keyDifferenceStyles.icon} />
                </div>
            </div>
        </section>
    );
};

export default KeyDifference;
